/**
 * Timeline data for the history page
 * Each item represents a historical event in the Wiest Group timeline
 */
export type HistoryItemT = {
  year: string;
  html: string;
};

export const HISTORY_ITEMS: HistoryItemT[] = [
  {
    year: "1896",
    html: `
      <div class="text-foreground">Gründung der Donges & Wiest OHG</div>
      <p class="text-foreground">Josef Wiest und Jakob Donges gründen an der Grafenstraße in Darmstadt die Donges & Wiest OHG.</p>
    `,
  },
  {
    year: "1930",
    html: `
      <div class="text-foreground">Umzug</div>
      <p class="text-foreground">Umzug in die Heinrichstraße 52 in Darmstadt.</p>
    `,
  },
  {
    year: "1944",
    html: `
      <div class="text-foreground">Zerstörung des Betriebs Heinrichstraße</div>
    `,
  },
  {
    year: "1945",
    html: `
      <div class="text-foreground">Wiederaufbau</div>
    `,
  },
  {
    year: "1948",
    html: `
      <div class="text-foreground">Das Autohaus Wiest wird VW-Großhändler</div>
    `,
  },
  {
    year: "1956",
    html: `
      <div class="text-foreground">An der Riedstraße entsteht ein modernes Reparaturwerk</div>
    `,
  },
  {
    year: "1968",
    html: `
      <div class="text-foreground">Wiest wird Großhändler der Auto-Union (heute Audi AG)</div>
    `,
  },
  {
    year: "1969",
    html: `
      <div class="text-foreground">Wiest erhält die Porsche-Vertretung für Südhessen</div>
    `,
  },
  {
    year: "1972",
    html: `
      <div class="text-foreground">Neubau Hilpertstraße in Darmstadt und eines Filialbetriebes in Bensheim.</div>
    `,
  },
  {
    year: "1975",
    html: `
      <div class="text-foreground">VW und Audi übernehmen den Fahrzeug- und Teilegroßhandel in eigener Regie.</div>
    `,
  },
  {
    year: "1986",
    html: `
      <div class="text-foreground">Erweiterung an der Hilpertstraße.</div>
    `,
  },
  {
    year: "1987",
    html: `
      <div class="text-foreground">Einführung der direkten Reparatur-Annahme "Auto-Check".</div>
    `,
  },
  {
    year: "1995",
    html: `
      <div class="text-foreground">Umbau des Betriebes Bensheim.</div>
    `,
  },
  {
    year: "1996",
    html: `
      <div class="text-foreground">WIEST wird 100 Jahre alt.</div>
    `,
  },
  {
    year: "1996 bis 1998",
    html: `
      <div class="text-foreground">Um- und Neubau der Betriebe Hilpertstraße und Riedstraße in Darmstadt.</div>
    `,
  },
  {
    year: "2004",
    html: `
      <div class="text-foreground">Eröffnung des neuen Gebrauchtwagenzentrums Darmstadt mit 900 Quadratmetern überdachter Ausstellungsfläche und Präsentationsmöglichkeit für 200 Fahrzeuge im Freigelände.</div>
    `,
  },
  {
    year: "Oktober 2005",
    html: `
      <div class="text-foreground">Eröffnung des neuen Audi Zentrums an der Hilpertstraße in Darmstadt.</div>
    `,
  },
  {
    year: "Februar 2006",
    html: `
      <div class="text-foreground">Skoda-Verkauf und -Werkstatt werden von der Ried- in die Hilpertstraße verlegt.</div>
    `,
  },
  {
    year: "Mai 2006",
    html: `
      <div class="text-foreground">Baubeginn für die neuen VW-Verkaufsräume in Bensheim.</div>
    `,
  },
  {
    year: "März 2007",
    html: `
      <div class="text-foreground">Eröffnung des neuen VW-Verkaufsgebäudes in Bensheim.</div>
    `,
  },
  {
    year: "2008",
    html: `
      <div class="text-foreground">VW zertifiziert die WIEST Autohäuser in Darmstadt und in Bensheim zum "Unfall Spezialisten".</div>
    `,
  },
  {
    year: "Februar 2009",
    html: `
      <div class="text-foreground">Eröffnung Porsche Zentrum Darmstadt an der Hilpertstraße.</div>
    `,
  },
  {
    year: "November 2016",
    html: `
      <div class="text-foreground">Neueröffnung nach Umbau des Skoda-Verkaufsgebäude.</div>
    `,
  },
  {
    year: "September 2017",
    html: `
      <div class="text-foreground">Neueröffnung nach Umbau des VW-Verkaufsgebäude.</div>
    `,
  },
  {
    year: "Mitte 2018",
    html: `
      <div class="text-foreground">Erweiterung (ca. 3.000m²) des Gebrauchtwagenmarktes.</div>
    `,
  },
  {
    year: "Februar 2019",
    html: `
      <div class="text-foreground">Fertigstellung vom Umbau in der Riedstraße.</div>
    `,
  },
  {
    year: "2024",
    html: `
      <div class="text-foreground">Umbauten des Porsche Zentrum Darmstadt.</div>
    `,
  },
];
